import styled from '@emotion/styled';
import React from 'react';
import {
  useScaleChangeFn,
  ZoomControls
} from '../../../../components/Timeline';

export const TaskTimelineZoomControlsContainer = styled('div')<{stickyOffset?:number}>((p) => ({
  position: p.stickyOffset ? 'sticky' : 'unset',
  bottom: p.stickyOffset ? p.stickyOffset : 0,
  right: 0,
  display: 'flex',
  justifyContent: 'flex-end',
  '> *': {
    width: 300
  }
}));

const SCALE_MIN = 1;
const SCALE_MAX = 20;

export const TaskTimelineZoomControls = ({
  value,
  onChange
}: {
  value: number;
  onChange: (nextValue: number) => void;
}) => {
  return (
    <ZoomControls
      min={SCALE_MIN}
      max={SCALE_MAX}
      value={value}
      onChange={onChange}
    />
  );
};

export const useTaskTimelineScaleChangeRequest = (
  onChange: React.Dispatch<React.SetStateAction<number>>
) => {
  return useScaleChangeFn(onChange, SCALE_MIN, SCALE_MAX);
};
